import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  id: "confirmation-modal",
  class: "modal-open modal"
}
const _hoisted_2 = {
  key: 0,
  class: "text-lg font-bold"
}
const _hoisted_3 = { class: "py-4" }
const _hoisted_4 = { class: "modal-action" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
  confirmationText: {
    type: String,
    required: true,
  },
  confirmationHeader: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '410px',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["confirm", "cancel"],
  setup(__props) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-box relative",
      style: _normalizeStyle({ width: __props.width })
    }, [
      (__props.confirmationHeader)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(__props.confirmationHeader), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.confirmationText), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn-secondary mr-4 px-4", { 'btn-disabled': __props.isLoading }]),
          disabled: __props.isLoading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
        }, " Cancel ", 10, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn-primary px-4", { 'btn-disabled': __props.isLoading }]),
          disabled: __props.isLoading,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
        }, " Confirm ", 10, _hoisted_6)
      ])
    ], 4)
  ]))
}
}

})